import { Faq } from '../types'

export const faqs: Faq[] = [
  {
    question: 'Does the system fit into any pool or spa?',
    answer: 'Yes. Hydrosprings retrofits into any existing pool or spa \u2014 no re-plumbing, no resurfacing.',
  },
  {
    question: 'How long does it take to install?',
    answer:
      'Installation is performed by authorized personnel only. Text us and we will connect you with the closest certified installer and a scheduled window.',
  },
  {
    question: 'Does Hydrosprings meet all state pool regulations?',
    answer: 'Yes. It is legal and falls within regulations in all 50 states.',
  },
  {
    question: 'Does Hydrosprings require service?',
    answer:
      'Very little. You change the acid twice a month using 32% or higher \u2014 the acid never enters the pool, only the extracted ions. The probe is replaced approximately every six months.',
  },
  {
    question: 'When would I ever have to add chemicals?',
    answer:
      'Only for acts of God, high phosphates, or an unforeseen service error. Those chemicals then dissipate under normal Hydrosprings operation.',
  },
  {
    question: 'Is Hydrosprings safe?',
    answer:
      'Yes. The system is designed safe and operates on DC power to limit any risk of shock or electrical issues.',
  },
]
